module.exports = __webpack_public_path__ + "img/31-03.d61efdbe.png";